var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"float-left"},[_vm._v("Float left on all viewport sizes")]),_c('br'),_c('div',{staticClass:"float-right"},[_vm._v("Float right on all viewport sizes")]),_c('br'),_c('div',{staticClass:"float-none"},[_vm._v("Don't float on all viewport sizes")])])
}]

export { render, staticRenderFns }